export const placesDefault = [
  'Hemma inomhus',
  'Hemma utomhus',
  'Arbete',
  'Skola',
  'Annat',
];
